export enum WorkflowCanvasCustomEvent {
  Add = 'add',
  AddToStartOfBranch = 'add-to-start-of-branch',
  Select = 'select',
  ToggleCollapsed = 'toggle-collapsed',
}

export const NODE_WIDTH = 256;
export const GAP_STEP_CARDS_HORIZONTAL = 36;
